var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMediaPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6682 7.41644C12.1106 7.6758 12.1106 8.3242 11.6682 8.58357L5.99554 11.9087C5.55308 12.1681 5 11.8439 5 11.3252L5 4.67485C5 4.15612 5.55308 3.83192 5.99554 4.09128L11.6682 7.41644Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMediaPlay);
export default __webpack_public_path__ + "static/media/MediaPlay.77a4acbc732a75fb026df892a65cd9be.svg";
export { ForwardRef as ReactComponent };